import React from 'react';
import styles from '../../components/SectionSubTitle/SectionSubTitle.module.scss';

export type SectionSubTitleProps = {
  id?: string;
  className?: string;
};

export const SectionSubTitle: React.FC<SectionSubTitleProps> = ({ children, id, className = '' }) => (
  <h3 id={id ? id : ''} className={`${styles['section-sub-title']} ${className}`}>
    {children}
  </h3>
);
